import React from 'react';

const BikeIcon = (props) => {
  return (
    <img
      alt="Trasa rowerowa"
      src="/static/images/icons/place_types/bike.svg"
      {...props}
    />
  );
};

export default BikeIcon;
